import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';

interface IPageCp2017 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Cp2017Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemForage: IMenuItemForageClass,
    MenuItemEcran: IMenuItemEcranClass,
    cp2010Route: IRoute,
    cp1004Route: IRoute,
    $stateParams: any) {
    const vm: IPageCp2017 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            criteresRechercheCollapsable: false,
            criteresSuggeresVisibles: true,
            criteresRechercheOpened: true,
            effaceCriteres: true
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('refcleintcri', { default: $stateParams.refcleint, hidden: true }),
            new FormulaireItem('datdeb'),
            new FormulaireItem('datfin'),
            new FormulaireItem('indcap', { default: 'N' })
        ]),
        colonnesVisibles: [
            {
                nom: 'docaffnumdoc01', largeur: 160, menu: [
                    new MenuItemForage(
                        cp2010Route.NAME,
                        (rowData: any) => ({ id: rowData.docaffcleint01 }),
                        {
                            icon: 'exit_to_app',
                            iconButton: true,
                            fonction: 'BOUDIS'
                        }
                    )
                ]
            },
            {
                nom: 'docaffnumref01', largeur: 300, menu: [
                    new MenuItemEcran('',
                        cp1004Route.NAME,
                        (rowData: any) => ({ doccleint: rowData.doccleintref }),
                        {
                            icon: 'launch',
                            iconButton: true,
                            fonction: 'BOUDSR'
                        }
                    )
                ]
            },
            { nom: 'docaffdat01', largeur: 126 },
            { nom: 'docdatdue', largeur: 126 },
            { nom: 'dscmntreq', largeur: 130 },
            { nom: 'dscmntrec', largeur: 130 }
        ],
        colonnesFixesDroite: [
            { nom: 'dscmntsld', largeur: 130 }
        ],
        colonnesCachees: [
            'doccleintref',
            'ecrcod',
            'docaffcleint01'
        ]
    };
}
